import React, { useState, useEffect, useRef } from 'react'
import { useImmer } from "use-immer"
import { Radio, Tabs, Table, Alert, Button, Col, Row, Modal, Space, Checkbox, Popover, Card, Switch, Select, Tooltip } from 'antd'
import dayjs from 'dayjs';
import { jsPDF } from 'jspdf';
import CreditSummaryTable from './CrediReport/CreditSummaryTable'
import CreditSummaryReview from './CrediReport/CreditSummaryReview'
import './CreditReport.css'
import './newCreditReport.css'
import { DownOutlined, UpOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { useSelector } from 'react-redux'
import { checkAccess } from "./Auth"
import { UR_Owner } from './State'
import { func } from 'prop-types';
const { TabPane } = Tabs


export default function NewCreditReport(props) {
    const [modal, contextHolder] = Modal.useModal()
    const application = useSelector(state => {

        return state.application
    })
    const urlParams = window.location.pathname.replace('/app/borrower/', '')

    const [user, setUser] = useImmer({
        borrower: {},
        coborrower: {},
        hascoborrower: ''
    })
    const [CheckLoading, setCheckLoading] = useImmer(false)
    const [creditLiability, setCreditLiability] = useImmer([])
    const [creditLoanType, setCreditLoanType] = useImmer([])
    const [accountStatus, setAccountStatus] = useImmer([])
    const [currentDataSource, setCurrentDataSource] = useImmer([])
    const [currentTable, setCurrentTable] = useImmer(null)
    const [isSwitch, setIsSwitch] = useImmer(false)
    const [credit, setCredit] = useImmer('')
    const [status, setState] = useImmer('')
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isConsentOpen, setIsConsentOpen] = useState(false)
    const [parties, setParties] = useImmer([])
    const [isChecked, setIsChecked] = useState(['borrower', 'coborrower'])
    const partiesReplace = [
        { role: '', value: '', title: 'ExperianFairIsaac', factors: [] },
        { role: '', value: '', title: 'FICORiskScoreClassic04', factors: [] },
        { role: '', value: '', title: 'EquifaxBeacon5.0', factors: [] }
    ]
    const [checkButton, setCheckButton] = useState(true)
    const [checkIndividualCreditAccount, setCheckIndividualCreditAccount] = useState(true)
    const [errorData, setErrorData] = useImmer({
        error: false,
        content: ''
    })
    const [creditRadio, setCreditRadio] = useState('')
    const [creditReports, setCreditReports] = useState([])
    const [consentType, setConsentType] = useState(undefined)
    const [openNotice, setOpenNotice] = useState(false)
    const currentType = {
        SoftPull: "softCheck",
        HardPull: 'hardCheck'
    }
    const [creditConsentStatus, setCreditConsentStatus] = useState([])
    const [handleRole, setHandleRole] = useState('')
    const { Option } = Select
    const [selectAccount, setSelectAccount] = useState(null)
    const [accountOptions, setAccountOptions] = useState({
        SoftPull: [],
        HardPull: []
    })
    const [reviewModal, setReviewModal] = useState(false)
    const [excludeZeroBalance, setExcludeZeroBalance] = useState(true)
    const [excludeClosed, setExcludeClosed] = useState(true)
    const [creditCheckDateOptions, setCreditCheckDateOptions] = useState([])
    const [creditCheckDate, setCreditCheckDate] = useState('')
    const vendorsList = {
        'KCBCredit': 'KCB Credit',
        'AdvantageCredit': 'Advantage Credit',
        'CreditTechnology': 'Credit Technology',
        'CreditTechnologies': 'Credit Technologies',
        'PremiumCreditBureau': 'Premium Credit Bureau',
        'PremiumCreditDataCDC': 'Premium Credit Data (CDC)',
        'Xactus': 'Xactus',
    }
    const [loadingCreditSummaryTable, setLoadingCreditSummaryTable] = useState(true)

    useEffect(() => {
        const creditConsentData = JSON.parse(localStorage.getItem('creditConsentData'));

        let updatedStatus = [
            {
                role: 'borrower',
                isConsent: false,
                isConsentType: '',
            }
        ]
        if (application.hascoborrower === 'withcoborrower') {
            updatedStatus.push({
                role: 'coborrower',
                isConsent: false,
                isConsentType: '',
            })
        }
        if (creditConsentData && creditConsentData.loanID === urlParams) {
            const consentMap = creditConsentData.creditConsentStatus.reduce((acc, item) => {
                acc[item.role] = item
                return acc
            }, {})

            updatedStatus = updatedStatus.map(item => {
                const matchedItem = consentMap[item.role];
                return {
                    ...item,
                    isConsent: matchedItem ? matchedItem.isConsent : item.isConsent,
                    isConsentType: matchedItem ? matchedItem.isConsentType : item.isConsentType,
                }
            })
        }
        setCreditConsentStatus(updatedStatus)
        setUser({
            borrower: application.borrower,
            coborrower: application.coborrower,
            hascoborrower: application.hascoborrower
        })
        getCreditReport()
        getAllAccouts()
    }, [])
    const modalCancel = () => {
        setReviewModal(false)
    }
    const onConfirm = (link) => {
        setReviewModal(false)
        props.changeStep('1003View', 'borrower', link)
    }
    const hasCoBorrowerStatus = () => {
        return application.hascoborrower === 'withcoborrower'
    }
    const getSummaryData = () => {
        const fields = [
            {
                title: 'Name',
                getBorrowerValue: () => formatName(application.borrower),
                getCoBorrowerValue: () => formatName(application.coborrower)
            },
            {
                title: 'SSN',
                getBorrowerValue: () => application.borrower.socialsecurity ? 
                    application.borrower.socialsecurity.replace(/(\d{3}-\d{2}-)(\d{4})/g, '*** - ** - $2') : '--',
                getCoBorrowerValue: () => application.coborrower.socialsecurity ? 
                    application.coborrower.socialsecurity.replace(/(\d{3}-\d{2}-)(\d{4})/g, '*** - ** - $2') : '--'
            },
            {
                title: 'Date of birth',
                getBorrowerValue: () => application.borrower.dateofbirth === '' ? 
                    '--' : dayjs(application.borrower.dateofbirth).format('MM/DD/YYYY'),
                getCoBorrowerValue: () => application.coborrower.dateofbirth === '' ? 
                    '--' : dayjs(application.coborrower.dateofbirth).format('MM/DD/YYYY')
            },
            {
                title: 'Address',
                getBorrowerValue: () => formatAddress('borrower'),
                getCoBorrowerValue: () => formatAddress('coborrower')
            }
        ];
        return (
            <div className='credit-summary-card-info'>
                {fields.map((field, index) => (
                    <div key={index} className='credit-summary-column'>
                        <div className='credit-summary-field-row'>
                            <div className='credit-summary-field-title'>{field.title === 'Name' ? 'Borrower' : field.title}</div>
                            <div className='credit-summary-value'>{field.getBorrowerValue()}</div>
                        </div>
                        {hasCoBorrowerStatus() && (
                            <div className='credit-summary-field-row'>
                                <div className='credit-summary-field-title'>{field.title === 'Name' ? 'Co-borrower' : field.title}</div>
                                <div className='credit-summary-value'>{field.getCoBorrowerValue()}</div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        );
    }
    const borrowerMarried = () => {
        return application.married && application.hascoborrower === 'withcoborrower' && application.coborrower.maritalstatus === 'married'
    }
    const handleSelectChange = (value) => {
        const selectedReport = creditReports.find(report => report.id === value)
        if (selectedReport) {
            setCreditReport(selectedReport)
            setCreditCheckDate(value)
        }
    }
    const camelCaseToSpaces = (str) => {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2')
    }
    const handleFileChange = (index) => {
        const selectedAccount = {
            ...accountOptions[creditRadio][index],
            index
        }
        setSelectAccount(selectedAccount)
    }
    const columns = [
        {
            title: 'Name',
            dataIndex: 'creditorName',
            key: 'name',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
        {
            title: 'Remaining Balance',
            dataIndex: 'unpaidBalanceAmount',
            key: 'balance',
            render: (_, record) => (
                <div style={{ color: '#222' }}>${_ === '' ? '0.00' : Number(_).toFixed(2)}</div>
            ),
        },
        {
            title: 'Mo. pay',
            dataIndex: 'monthlyPaymentAmount',
            key: 'payment',
            render: (_, record) => (
                <div style={{ color: '#222' }}>${_ === '' ? '0.00' : Number(_).toFixed(2)}</div>
            ),
        },
        {
            title: 'Mo. left to pay',
            dataIndex: 'monthsRemainingCount',
            key: 'monthly',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
        {
            title: 'Opened date',
            dataIndex: 'openedDate',
            key: 'date',
            sorter: (a, b) => {
                if (a.date < b.date) {
                    return -1
                }
                if (a.date > b.date) {
                    return 1
                }
                return 0
            },
            render: (_, record) => (
                <div style={{ color: '#222' }}>{dayjs(_).format('MM/DD/YYYY')}</div>
            ),
        },
        {
            title: 'Credit loan type',
            dataIndex: 'loanType',
            key: 'credit',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{camelCaseToSpaces(_)}</div>
            ),
        },
        {
            title: 'Acct status',
            dataIndex: 'accountStatus',
            key: 'account',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
    ]
    const columnsSummary = [
        {
            title: 'Account Type',
            dataIndex: 'Type',
            key: 'Type',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{camelCaseToSpaces(_)}</div>
            ),
        },

        {
            title: 'Balance',
            dataIndex: 'Balance',
            key: 'Balance',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
        {
            title: 'Count',
            dataIndex: 'Count',
            key: 'Count',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
        {
            title: 'Payment',
            dataIndex: 'Payment',
            key: 'Payment',

            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
        {
            title: 'PastDue',
            dataIndex: 'PastDue',
            key: 'PastDue',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
        {
            title: 'HighCredit',
            dataIndex: 'HighCredit',
            key: 'HighCredit',
            render: (_, record) => (
                <div style={{ color: '#222' }}>{_}</div>
            ),
        },
    ]
    const type = {
        "ExperianFairIsaac": "Experian",
        "EquifaxBeacon5.0": 'Equifax',
        'TransUnion': 'TransUnion',
        'FICORiskScoreClassic': 'TransUnion'
    }
    const handleConsent = (role) => {
        setHandleRole(role)
        setIsConsentOpen(true)
    }
    const handleConsentType = (value) => {
        setConsentType(value)
    }
    const handleConsentClose = () => {
        setIsConsentOpen(false)
        setConsentType(undefined)
    }
    const consentConfirm = () => {
        setCreditConsentStatus(prevStatus => {
            const updatedStatus = prevStatus.map(item =>
                item.role === handleRole
                    ? { ...item, isConsent: true, isConsentType: consentType }
                    : item
            )
            let obj = {
                'loanID': urlParams,
                'creditConsentStatus': updatedStatus
            }
            localStorage.setItem('creditConsentData', JSON.stringify(obj))
            return updatedStatus
        })
        handleConsentClose()
        setOpenNotice(true)
        setTimeout(() => {
            setOpenNotice(false)
        }, 5000)
    }
    const formatDate = (dateString) => {
        return dayjs(dateString, 'MM/DD/YYYY').format('MMMM D, YYYY')
    }
    const formatCreditConsentDate = (dateString) => {
        if (!dateString) return '--'
        const d = dayjs(dateString)
        if (!d.isValid()) return '--'
        return d.toDate().toLocaleString('en-US', { timeZone: 'America/Los_Angeles', dateStyle: 'long', timeStyle: 'short' }) + ' PST'
    }
    const downloadCreditAuthorization = () => {
        const borrowerName = formatName(application.borrower)
        const borrowerEmail = application.borrower?.email || '—'
        const consentDatePst = formatCreditConsentDate(application.creditconsentdate)
        const companyName = application.brokerinfo?.name || '—'
        const line1 = `Accepted by ${borrowerName} (${borrowerEmail}) on ${consentDatePst}`
        const line2 = `Accepted for ${companyName}`
        const line3 = `By clicking the "I/We consent to a credit check..." checkbox, I/we hereby grant permission to obtain all information deemed necessary to process this mortgage loan application. This information includes, but is not limited to, past and present employment status, deposit accounts, past and present consumer credit record, mortgage record, and/or rental record.`
        const doc = new jsPDF('p', 'pt', 'a4')
        const margin = 72
        const maxWidth = doc.internal.pageSize.getWidth() - margin * 2
        const lineHeight = 14
        let y = margin
        doc.setFontSize(11)
        doc.setTextColor(255, 0, 0)
        doc.text(line1, margin, y)
        y += lineHeight
        doc.text(line2, margin, y)
        y += lineHeight * 1.5
        doc.setTextColor(0, 0, 0)
        const wrappedLines = doc.splitTextToSize(line3, maxWidth)
        doc.text(wrappedLines, margin, y)
        doc.save('Credit_Authorization.pdf')
    }
    const formatAddress = (type) => {
        return `${user[type].presentaddressstreet}, ${user[type].presentaddresscity}, ${user[type].presentaddressstate}, ${user[type].presentaddresszip}, USA`
    }
    const getCreditaccountconfig = async () => {
        try {
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch(`/los/getcreditaccountconfig`, {
                method: 'get',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            const data = await response.json()
            const isSet = data?.Accounts.length > 0 ? true : false
            setCheckButton(isSet)
            return data
        } catch (error) {
            return null
        }

    }
    const getFeatureCustomization = async () => {
        try {
            let token = sessionStorage.getItem("ZeitroA")
            const response = await fetch(`/los/getfeaturecustomization`, {
                method: 'get',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            const data = await response.json()
            const isSet = data?.CreditAccounts?.length > 0 ? true : false
            setCheckIndividualCreditAccount(isSet)
            return data
        } catch (error) {
            return null
        }

    }
    const getAllAccouts = async () => {
        try {
            const [creditAccountConfig, featureCustomization] = await Promise.all([
                getCreditaccountconfig(),
                getFeatureCustomization()
            ])

            const featureCreditAccounts = (featureCustomization.CreditAccounts || [])
            const adminCreditAccounts = (creditAccountConfig.Accounts || []).filter(item => item.Type).map(account => {
                const hasDefault = featureCreditAccounts.some(featureAccount => 
                    featureAccount.Type === account.Type && featureAccount.IsDefault
                )
            
                return {
                    ...account,
                    IsDefault: !hasDefault
                }
            })

            const mergeAccounts =  [...featureCreditAccounts, ...adminCreditAccounts]

            const sortAccounts = (accounts) => {
                return accounts.sort((a, b) => {
                    if (a.IsDefault && !b.IsDefault) return -1
                    if (!a.IsDefault && b.IsDefault) return 1
                    return 0
                })
            }

            const softPullAccounts = sortAccounts(mergeAccounts.filter(acc => acc.Type === 'SoftPull'))
            const hardPullAccounts = sortAccounts(mergeAccounts.filter(acc => acc.Type === 'HardPull'))
            
            setAccountOptions({
                SoftPull: softPullAccounts,
                HardPull: hardPullAccounts
            })
        } catch (error) {
            console.error("Error fetching all data:", error)
        }
    }
    const handleExcludeZeroBalanceChange = (checked) => {
        setExcludeZeroBalance(checked)
    }
    
    const handleExcludeClosedChange = (checked) => {
        setExcludeClosed(checked)
    }
    function formatPersonName(person) {
        if (!person || !person.lastName) return '--';
        let name = person.lastName;
        if (person.firstName) name += `, ${person.firstName}`;
        if (person.middleName) name += ` ${person.middleName}`;
        if (person.suffixName) name += ` ${person.suffixName}`;
        return name;
    }
    const convertParties = (data) => {
        // 以borrowers为基准，遍历每个borrower
        return data.borrowers.map(borrower => {
            // 找到所有scoreModels中role与当前borrower.role一致的项
            const credit = (data.scoreModels || [])
                .filter(model => model.role === borrower.role)
                .map(model => ({
                    value: model.scoreValue,
                    title: model.modelNameType,
                    factors: model.factors ? model.factors.map(f => f.text || f) : []
                }));
            return {
                name: formatPersonName(borrower),
                role: borrower.role,
                credit
            };
        });
    }
    return (
        <>
            {contextHolder}
            <div style={{
                padding: '18px 36px'
            }}>

                <div style={{ fontFamily: 'Inter', fontSize: 20, fontWeight: 600, color: '#000', marginBottom: 12, lineHeight: '26px' }}>
                    <span>Credit report</span>
                </div>
                {!checkButton && !checkIndividualCreditAccount && <div className='setUpAccount'>
                    <div>
                        <div style={{ color: "#222", fontSize: 16, fontWeight: 600, lineHeight: 'normal', marginBottom: 6 }}>No account connected</div>
                        <div style={{ color: "#222", fontSize: 14, lineHeight: 'normal', letterSpacing: '0.2px' }}>{checkAccess([UR_Owner]) ? "Your credit account has not been set up. Please proceed to set up your team credit account in the management page, or set up your individual credit account in account settings." : "The credit account has not been set up. Please contact your admin to set up the team credit account, or set up your individual credit account in account settings."}</div>
                    </div>
                    <div>
                        <Button className='credit-account-connect-btn' onClick={() => {

                            if (checkAccess([UR_Owner])) {
                                window.open('/app/management', '_self')
                            } else {
                                modal.confirm({
                                    title: '',
                                    icon: null,
                                    content: <div>Please contact your admin to set up the team credit account, or set up your individual credit account in account settings</div>,
                                    cancelButtonProps: { style: { display: 'none' } },
                                })
                            }

                        }}>connect now</Button>

                    </div>
                </div>}
                <Row className='credit-report-top-bar'>
                    <Col span={24} sm={12}>
                        <Select                        
                            className='check-date-select'
                            value={creditCheckDate}
                            onChange={handleSelectChange}
                            options={creditCheckDateOptions}
                            placeholder="Select credit check date"
                        />
                    </Col>
                    <Col span={24} sm={12}>
                        <div style={{display: 'flex', justifyContent: 'flex-end', gap: '16px'}}>
                            <Button 
                                className='credit-report-btn credit-report-import' 
                                type="primary"
                                disabled={creditReports.length === 0}
                                onClick={() => {
                                    setReviewModal(true)
                                }}
                            >
                                Import to 1003
                            </Button>
                            <Button 
                                className='credit-report-btn credit-report-download' 
                                type="primary"
                                disabled={creditReports.length === 0}
                                onClick={downloadCreditReport}
                            >
                                Download
                            </Button>
                            {
                                checkButton || checkIndividualCreditAccount ?
                                    <Button type="primary" className='credit-report-btn credit-report-check' onClick={() => {
                                        setIsModalOpen(true)
                                    }}>Check credit</Button>
                                    : <Tooltip placement="left" title={checkAccess(["Owner"]) ? 'This feature requires a credit account. Please configure your credit account in Management to unlock it.' : 'This feature requires a credit account. Please contact your account admin to configure your credit account in Management, or set up your individual credit account in account settings to unlock it.'}>
                                        <Button disabled={true} className='credit-report-btn credit-report-check' onClick={() => {
                                            setIsModalOpen(true)
                                        }}>Check credit</Button>
                                        </Tooltip>
                            }
                        </div>
                    </Col>
                </Row>
                <div >
                    <Tabs className='credit-report-tabs' defaultActiveKey="CreditSummary">
                        <TabPane tab="Credit summary" key="CreditSummary">
                            <div>
                                <div className='credit-summary-card'>
                                    <div className='credit-summary-card-title'>
                                        <img src={hasCoBorrowerStatus() ? '/images/double-person.svg' : '/images/single-person.svg'} />
                                        <div className='credit-summary-card-title-text'>{hasCoBorrowerStatus() ? 'Joint Credit Summary' : 'Individual credit summary'}</div>
                                    </div>
                                    {getSummaryData()}
                                    {application.creditconsented && (
                                        <div className='credit-summary-card-info' style={{ fontSize: 14, fontWeight: 500, fontFamily: 'Inter', color: '#586570', marginTop: 12, paddingTop: 12, borderTop: '1px solid #ECECEC' }}>
                                            Borrower has consented to the credit check on {formatCreditConsentDate(application.creditconsentdate)}.{' '}
                                            <a href="#" onClick={(e) => { e.preventDefault(); downloadCreditAuthorization(); }} style={{ color: '#1890ff' }}>Download credit authorization</a>
                                        </div>
                                    )}
                                </div>
                                <CreditSummaryTable
                                    accounts={creditLiability}
                                    loading={loadingCreditSummaryTable}
                                    onExcludeZeroBalanceChange={handleExcludeZeroBalanceChange}
                                    onExcludeClosedChange={handleExcludeClosedChange}
                                    onOwnershipChange={handleOwnershipChange}
                                />
                                <CreditSummaryReview 
                                    open={reviewModal}
                                    propertySource={application.hascoborrower === "withcoborrower" ? 'all' : 'borrower'}
                                    accounts={creditLiability} 
                                    initialExcludeZeroBalance={excludeZeroBalance} 
                                    initialExcludeClosed={excludeClosed}
                                    defaultCheckedType='all'
                                    onCancel={modalCancel} 
                                    onConfirm={(link) => onConfirm(link)} 
                                />
                            </div>
                        </TabPane>
                        <TabPane tab="Credit reports" key="CreditReports">
                            {errorData.error && <div style={{ color: "#CB8600", display: 'flex', alignItems: 'center', marginTop: '10px', fontWeight: 500 }}><ExclamationCircleFilled /> <span style={{ marginLeft: '10px' }}>
                                Credit check unavailable</span></div>}
                            {errorData.error && <Alert style={{ marginTop: "10px" }} message={<div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>

                                <div>{errorData.content}</div>
                                <div>
                                    <Popover placement='bottom' content={
                                        <div style={{
                                            color
                                                : "#222",
                                        }}>
                                            <div style={{
                                                minWidth: 150,
                                                fontSize: '28px',
                                                paddingBottom: 10,
                                                paddingLeft: 4,
                                                borderBottom: "1px solid #DBDCDE"
                                            }}>{user.borrower.firstname} {user.borrower.lastname}</div>

                                            <div style={{ marginTop: 10, }}>
                                                <div className='PopoverTitle'>Phone</div>
                                                <div>{user.borrower.homephone === '' ? '--' : user.borrower.homephone} </div>
                                            </div>
                                            <div style={{ marginTop: 10 }}>
                                                <div className='PopoverTitle'>Email</div>
                                                <div style={{ textDecoration: 'underline' }}>{user.borrower.email} </div>
                                            </div>

                                        </div>


                                    }>
                                        <Button className='ant-btn-default-zeitro'>Contact borrower</Button>
                                    </Popover>

                                </div>

                            </div>} type="warning" />}
                            {/* <Tabs> */}
                            {
                                parties.map((partiesItem, partiesIndex) => {
                                    const newCredit = partiesItem.credit.length ? partiesItem.credit : partiesReplace
                                    return (
                                        // <TabPane tab={partiesItem.name} key={partiesIndex}>
                                        <Space direction="vertical" size="middle" style={{ display: 'flex', marginTop: 24 }}>
                                            <div style={{ fontFamily: 'Inter', color: "#222", fontSize: 16, fontWeight: 500, lineHeight: '24px', marginBottom: -4 }}>
                                                <span>{partiesItem.name}</span>
                                            </div>
                                            {newCredit.map((item, index) => {

                                                return <Card className='credit-history-card' style={!checkButton && !checkIndividualCreditAccount ? { filter: 'blur(1px)' } : {}}>
                                                    <div style={{ display: "flex", justifyContent: "space-between", gap: 36, padding: '0 18px'}}>
                                                        <div>
                                                            <div style={{ height: 30, marginBottom: 9}}>{getImg(item.title)}</div>
                                                            <div className='reportScore'>Score</div>
                                                            <div className='reportValue' style={item.value === '' ? {color: '#DBDCDE'} : {}}>{item.value === '' ? '---' : item.value}</div>


                                                        </div>
                                                        <div style={{ width: '100%' }} >
                                                            <div style={{ fontFamily: 'Inter', color: '#222', fontSize: 16, fontWeight: 500, height: 30, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                                <div>{getName(item.title)}</div>
                                                                <div>

                                                                    <div style={{ cursor: "pointer", height: 24, width: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => {
                                                                        if (currentTable === `${partiesIndex}${index}`) {
                                                                            setCurrentTable(null)
                                                                        } else {
                                                                            setCredit('')
                                                                            setState('')
                                                                            setIsSwitch(false)
                                                                            setCurrentTable(`${partiesIndex}${index}`)
                                                                            let list = []
                                                                            if (item.factors.length > 0) {
                                                                                list = creditLiability.filter(
                                                                                    info =>
                                                                                    info.repositories.includes(type[item.title.includes('FICORiskScoreClassic') ? 'TransUnion' : item.title]) &&
                                                                                    info.role === partiesItem.role
                                                                                )
                                                                            }
                                                                            setCurrentDataSource(list)
                                                                        }

                                                                    }}>
                                                                        {currentTable === `${partiesIndex}${index}` ? <UpOutlined /> : < DownOutlined />}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {item.factors.length > 0 ?
                                                                <div className='factorScore'>
                                                                    <div className='FactorsTitle'>Factors Influencing Credit Score:</div>
                                                                    <ul style={{
                                                                        paddingLeft : '24px',
                                                                        color: 'rgba(34, 34, 34, 0.90)',
                                                                        fontSize: '14px', 
                                                                        margin: '4px 0 0',
                                                                        lineHeight: '18px'
                                                                    }}>
                                                                        {
                                                                            item.factors.map((factorsItem) => {

                                                                                return (
                                                                                    <li key={factorsItem}>{factorsItem}</li>
                                                                                )
                                                                            })
                                                                        }
                                                                    </ul>
                                                                </div> : <div className='factorScore' style={{ textAlign: "center", height: 64, display: 'flex', alignItems: "center", justifyContent: 'center' }}>
                                                                    <div style={{ color: "#6E6E70", fontSize: "16px", lineHeight: '20px' }}>Credit not pulled</div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    {/* <div style={{ width: '100%', height: '1px', background: "#DBDCDE", marginTop: "10px" }}></div> */}
                                                    {

                                                        currentTable === `${partiesIndex}${index}` ? <div style={{ marginTop: "10px" }}>                                                   
                                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", padding: '0 18px' }}>
                                                                <div style={{display: 'flex', alignItems: "center"}}>
                                                                    <Switch value={isSwitch} onChange={(e) => {
                                                                        setIsSwitch(e)
                                                                        const list = creditLiability.filter((info => info.repositories.includes(type[item.title.includes('FICORiskScoreClassic') ? 'TransUnion' : item.title]))).filter(info => info.loanType.includes(credit === undefined ? '' : credit)).filter(info => info.accountStatus.includes(status === undefined ? '' : status)).filter((info) => {
                                                                            if (e) {
                                                                                return Number(info.monthlyPaymentAmount) !== 0
                                                                            } else {
                                                                                return info
                                                                            }


                                                                        })
                                                                        setCurrentDataSource(list)
                                                                    }}></Switch> <div style={{fontFamily: 'Inter', fontSize: 16, color: '#222', lineHeight: 'normal', paddingLeft: 10,}}>Exclude 0 monthly payment records</div>
                                                                </div>
                                                                <div>
                                                                    <Select
                                                                        className='credit-history-select'
                                                                        placeholder='Credit loan type'
                                                                        allowClear
                                                                        onChange={(e) => {
                                                                            setCredit(e)
                                                                            const list = creditLiability.filter((info => info.repositories.includes(type[item.title.includes('FICORiskScoreClassic') ? 'TransUnion' : item.title]))).filter(info => info.loanType.includes(e === undefined ? '' : e)).filter(info => info.accountStatus.includes(status === undefined ? '' : status)).filter((info) => {
                                                                                if (isSwitch) {
                                                                                    return Number(info.monthlyPaymentAmount) !== 0
                                                                                } else {
                                                                                    return info
                                                                                }


                                                                            })
                                                                            setCurrentDataSource(list)
                                                                        }}
                                                                        style={{ width: '250px', height: '38px', marginRight: '16px' }} options={creditLoanType}></Select>
                                                                    <Select
                                                                        className='credit-history-select'
                                                                        allowClear
                                                                        onChange={(e) => {

                                                                            setState(e)
                                                                            const list = creditLiability.filter((info => info.repositories.includes(type[item.title.includes('FICORiskScoreClassic') ? 'TransUnion' : item.title]))).filter(info => info.loanType.includes(credit === undefined ? '' : credit)).filter(info => info.accountStatus.includes(e === undefined ? '' : e)).filter((info) => {
                                                                                if (isSwitch) {
                                                                                    return Number(info.monthlyPaymentAmount) !== 0
                                                                                } else {
                                                                                    return info
                                                                                }


                                                                            })
                                                                            setCurrentDataSource(list)
                                                                        }}
                                                                        placeholder='Status'
                                                                        style={{ width: '150px', height: '38px' }} options={accountStatus}></Select>

                                                                </div>

                                                            </div>

                                                            <Table className='credit-history-table' style={{ marginTop: '10px' }} columns={columns} dataSource={currentDataSource}
                                                            ></Table>
                                                        </div> : <></>
                                                    }

                                                </Card>
                                            })}

                                        </Space>
                                        // </TabPane>
                                    )
                                })

                            }

                            {/* </Tabs> */}
                        </TabPane>
                    </Tabs>
                    {/* <div>
                        <Radio.Group value={isShowSummary} onChange={(e) => {

                            setIsShowSummary(e.target.value)
                        }} defaultValue="CreditSummary">
                            <Radio value="CreditHistory">Credit reports</Radio>
                            <Radio value="CreditSummary">Credit summary</Radio>


                        </Radio.Group>

                    </div> */}


                </div>


                {/* {
                    isShowSummary === 'CreditSummary' ?
                  
                 

                } */}



            </div >
            <Modal
                className='credit-check-modal'
                styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.75)' } }}
                destroyOnClose
                width={976}
                open={isModalOpen}
                title="Credit check"
                onCancel={() => {
                    setIsModalOpen(false)
                    setSelectAccount(null)
                    setCreditRadio('')
                }}
                footer={
                    <div className='btn-wrap'>
                        <div></div>
                        <Button className='credit-check-btn' type='primary' disabled={creditConsentStatus.some(item => !item.isConsent) || !selectAccount} loading={CheckLoading} onClick={async () => {
                            try {
                                setCheckLoading(true)
                                let token = sessionStorage.getItem("ZeitroA")
                                const account = {
                                    vendor: selectAccount.Vendor,
                                    userName: selectAccount.Username,
                                    password: selectAccount.Password
                                }
                                const response = await fetch(`/api/v1/credit/requestReport`, {
                                    method: 'POST',
                                    body: JSON.stringify({
                                        loanId: urlParams,
                                        reportType: currentType[creditRadio],
                                        account: account
                                    }),
                                    headers: {
                                        Authorization: "Bearer " + token,
                                        Cache: "no-cache"
                                    }
                                })
                                if (response.status !== 200) {
                                    const errorMessage = await response.text()
                                    console.log("Error response:", errorMessage)
                                    alert("We were unable to retrieve the credit report because the credit service returned the error message: " + errorMessage)
                                    setIsModalOpen(false)
                                    setSelectAccount(null)
                                    setCreditRadio('')
                                    setCheckLoading(false)
                                    return
                                }
                                const responseBody = await response.json()
                                if (responseBody.code !== 0) {
                                    alert(responseBody.errMessage)
                                    setSelectAccount(null)
                                    setCreditRadio('')
                                    setCheckLoading(false)
                                    return
                                }
                                setIsModalOpen(false)
                                setCheckLoading(false)
                                getCreditReport()
                            } catch (error) {
                                alert('An unexpected error occurred. Please try again later.')
                                setIsModalOpen(false)
                                setSelectAccount(null)
                                setCreditRadio('')
                                setCheckLoading(false)
                            }
                        }}>Proceed with credit check</Button>
                    </div>
                }
            >
                {getContent()}
            </Modal>
            <Modal
                className='consent-confirmation-modal'
                mask={false}
                centered
                destroyOnClose
                zIndex={1001}
                width={516}
                open={isConsentOpen}
                title="Consent confirmation"
                footer={[
                    <Button className='consent-confirmation-btn' type='link' onClick={handleConsentClose}>
                      Cancel
                    </Button>,
                    <Button className='consent-confirmation-btn' key="submit" type="primary" disabled={!consentType} onClick={consentConfirm}>
                      Confirm
                    </Button>]}
                onCancel={handleConsentClose}
            >
                    <div className='consent-confirmation-content'>
                        <div className='consent-confirmation-content-tips'>Please maintain the necessary documentation evidencing the borrower's consent if you obtain credit consent outside of Zeitro's borrower application.</div>
                        <div className='consent-confirmation-content-select'>
                            <div className='consent-select-label'>How was consent received?</div>
                            <Select
                                value={consentType}
                                style={{
                                    width: '100%',
                                }}
                                onChange={handleConsentType}
                                options={[
                                    {
                                    value: 'email',
                                    label: 'Email',
                                    }
                                ]}
                                placeholder="Please select"
                            />
                        </div>
                    </div>
            </Modal>
        </>

    )
    
    function getContent() {
        return <div className='borrowerContent'>
            <div>
                <div style={{ marginBottom: '40px' }}>
                    <div className='credit-check-title'>
                        How would you like to check credit?
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <Radio.Group style={{ display: "flex" }} value={creditRadio} onChange={(e) => {
                            setCreditRadio(e.target.value)
                            const selectedType = e.target.value
                            setCreditRadio(selectedType)
                            
                            const accounts = accountOptions[selectedType] || []
                            const defaultAccount = accounts.find(acc => acc.IsDefault)
                            
                            if (defaultAccount) {
                                const defaultIndex = accounts.findIndex(acc => acc.IsDefault)
                                setSelectAccount({
                                    ...defaultAccount,
                                    index: defaultIndex
                                })
                            } else {
                                setSelectAccount(null)
                            }
                        }}>
                            <label className='credit-check-select-radio' style={creditRadio === 'SoftPull' ? { borderColor: "#325CEB" } : {}}>
                                <Radio value='SoftPull'>Soft credit check</Radio>
                            </label>
                            <label className='credit-check-select-radio' style={creditRadio === 'HardPull' ? { borderColor: "#325CEB" } : {}}>
                                <Radio value='HardPull'>Hard credit check</Radio>
                            </label>
                        </Radio.Group>
                    </div>
                    {
                        creditRadio !== '' && (
                            <div className='credit-account-select-wrap'>
                                <div className='credit-check-select-label'>Select a credit account</div>
                                <Select
                                    style={{
                                        width: '100%',
                                        height: '50px',
                                    }}
                                    getPopupContainer={triggerNode => triggerNode.parentElement}
                                    className='credit-account-select'
                                    suffixIcon={<img src="/images/auto-reminder-select-arrow.svg" />}
                                    value={selectAccount ? `${creditRadio}-${selectAccount.index}` : undefined}
                                    placeholder='Select credit account'
                                    onChange={(value) => {
                                        const index = parseInt(value.split('-')[1])
                                        handleFileChange(index)
                                    }}
                                    optionLabelProp="label"
                                >
                                    {(accountOptions[creditRadio] || []).map((option, index) => (
                                        <Option 
                                            key={index} 
                                            value={`${creditRadio}-${index}`}
                                            label={
                                                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                    <img src='/images/credit-account-profile.svg' />
                                                    <div style={{ fontFamily: 'Inter', fontSize: 16, color: '#222', lineHeight: '20px' }}>
                                                        {vendorsList[option.Vendor]} - {option.Username}
                                                    </div>
                                                    {option.IsDefault && <div className='credit-account-default-tag'>Default</div>}
                                                </span>
                                            }
                                        >
                                            <span style={{ display: 'flex', alignItems: 'center', height: 38, gap: 8 }}>
                                                <div style={{ marginLeft: 8, fontFamily: 'Inter', fontSize: 16, color: '#222', lineHeight: '20px' }}>
                                                    {vendorsList[option.Vendor]} - {option.Username}
                                                </div>
                                                {option.IsDefault && <div className='credit-account-default-tag'>Default</div>}
                                            </span>
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                        )
                    }
                </div>
                <div className='credit-check-title'>
                    Borrowers
                </div>
                <div>
                    <Checkbox.Group onChange={(e) => {}} value={isChecked} style={{
                        display: "flex", flexDirection: 'column', justifyContent: 'space-around', marginBottom: '16px'


                    }}>
                        {!creditConsentStatus.find(item => item.role === 'borrower')?.isConsent && !borrowerMarried() && <div className='credit-check-consented-title'>The following borrower(s) hasn't consented to access their personal credit information yet, so they will not be pulled.</div>}
                        <div 
                            style={{
                                border: !creditConsentStatus.find(item => item.role === 'borrower')?.isConsent && !borrowerMarried() ? '1px solid #CB8600' : '1px solid #ECECEC',
                                borderBottom: borrowerMarried() ? 'none' : '1px solid #ECECE',
                                borderBottomLeftRadius: borrowerMarried() ? '0' : '8px',
                                borderBottomRightRadius: borrowerMarried() ? '0' : '8px',
                                marginBottom: borrowerMarried() ? '0' : '16px',
                                paddingBottom: borrowerMarried() ? '0' : '20px',
                            }} 
                            className='credit-check-borrowers-box' onClick={() => {

                            const borrower = isChecked.includes('borrower')
                            if (borrower) {
                                setIsChecked(isChecked.filter((item) => item !== 'borrower'))
                            } else {
                                setIsChecked([...isChecked, 'borrower'])
                            }

                        }}>
                            {/* <Checkbox value='borrower'></Checkbox> */}
                            <div className='credit-check-borrowers-top'>

                                <div className='personal-information'>
                                    <span >{formatName(user.borrower)}</span> 
                                    <span style={{
                                        fontWeight: 400
                                    }}> · SSN {user.borrower.socialsecurity}</span>
                                </div>
                                <div style={creditConsentStatus.find(item => item.role === 'borrower')?.isConsent ? { backgroundColor: "#D4F8D3", color: '#138D2E' } : { backgroundColor: "#F8E8D3", color: '#CB8600' }} className='credit-consent-status'>
                                    <img src={`/images/credit-${creditConsentStatus.find(item => item.role === 'borrower')?.isConsent ? 'confirmed' : 'unconfirmed'}.svg`} /><span>Credit consent</span>
                                </div>
                            </div>
                            <div style={{ color: "#586570", marginTop: '15px' }}>
                                <div className='credit-check-info-item'>
                                    <div className='info-item-label'>Date of birth:</div><div>{user.borrower.dateofbirth === '' ? '--' : formatDate(user.borrower.dateofbirth)}</div>
                                </div>
                                <div className='credit-check-info-item'>
                                    <div className='info-item-label'>Current address:</div><div>{user.borrower.presentaddressstreet === '' ? '--' : formatAddress('borrower')}</div>
                                </div>
                            </div>
                            <div className='credit-check-borrowers-bottom'>
                                {!creditConsentStatus.find(item => item.role === 'borrower')?.isConsent && <div className='credit-consent-btn' onClick={() => handleConsent('borrower')}>Consent confirmation</div>}
                            </div>
                            {borrowerMarried() && <div style={{ height: 1, backgroundColor: '#ECECEC', width: '100%', marginTop: '20px' }}></div>}
                        </div>
                        {user.hascoborrower === 'withcoborrower' && (
                            <>
                                {!creditConsentStatus.find(item => item.role === 'coborrower')?.isConsent && !borrowerMarried() && <div className='credit-check-consented-title'>The following borrower(s) hasn't consented to access their personal credit information yet, so they will not be pulled.</div>}
                                <div 
                                    style={{
                                        border: !creditConsentStatus.find(item => item.role === 'coborrower')?.isConsent && !borrowerMarried() ? '1px solid #CB8600' : '1px solid #ECECEC',
                                        borderTop: borrowerMarried() ? 'none' : '1px solid #ECECE',
                                        borderTopLeftRadius: borrowerMarried() ? '0' : '8px',
                                        borderTopRightRadius: borrowerMarried() ? '0' : '8px',
                                    }}
                                    className='credit-check-borrowers-box' onClick={() => {
                                    const coborrower = isChecked.includes('coborrower')
                                    if (coborrower) {
                                        setIsChecked(isChecked.filter((item) => item !== 'coborrower'))
                                    } else {
                                        setIsChecked([...isChecked, 'coborrower'])
                                    }
        
                                }}>
                                    {/* <Checkbox value='coborrower' ></Checkbox> */}
                                    <div className='credit-check-borrowers-top'>
                                        <div className='personal-information'>
                                            <span>{formatName(user.coborrower)}</span> <span style={{
                                                fontWeight: 400
                                            }}>·SSN {user.coborrower.socialsecurity}</span></div>
                                        <div style={creditConsentStatus.find(item => item.role === 'coborrower')?.isConsent ? { backgroundColor: "#D4F8D3", color: '#138D2E' } : { backgroundColor: "#F8E8D3", color: '#CB8600' }} className='credit-consent-status'>
                                            <img src={`/images/credit-${creditConsentStatus.find(item => item.role === 'coborrower')?.isConsent ? 'confirmed' : 'unconfirmed'}.svg`} /><span>Credit consent</span>
                                        </div>
                                    </div>
                                    <div style={{ color: "#586570", marginTop: '15px' }}>
                                        <div className='credit-check-info-item'>
                                            <div className='info-item-label'>Date of birth:</div><div>{user.coborrower.dateofbirth === '' ? '--' : formatDate(user.coborrower.dateofbirth)}</div>
                                        </div>
                                        <div className='credit-check-info-item'>
                                            <div className='info-item-label'>Current address:</div><div>{user.coborrower.presentaddressstreet === '' ? '--' : formatAddress('coborrower')}</div>
                                        </div>
                                    </div>
                                    <div className='credit-check-borrowers-bottom'>
                                        {!creditConsentStatus.find(item => item.role === 'coborrower')?.isConsent && <div className='credit-consent-btn' onClick={() => handleConsent('coborrower')}>Consent confirmation</div>}
                                    </div>
                                </div>
                            </>
                        )}
                        {borrowerMarried() && <div style={{ fontFamily: 'Inter', fontSize: 16, color: '#707070', lineHeight: '20px' }}>*A <span style={{textDecorationLine: 'underline'}}>joint credit pull</span> will be pulled for married co-borrowers.</div>}
                    </Checkbox.Group>

                </div>
            </div>

            <div className={`consent-confirmed-notice ${openNotice ? 'showNotice' : 'hideNotice'}`}>
                <div>Credit consent confirmed</div>
                <div className='consent-confirmed-notice-btn' onClick={() => setOpenNotice(false)}>Undo</div>
                <div className='consent-confirmed-notice-close' onClick={() => setOpenNotice(false)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect x="5.66406" y="19.8064" width="2" height="20" rx="1" transform="rotate(-135 5.66406 19.8064)" fill="white"/>
                        <rect x="4.25" y="5.66577" width="2" height="20" rx="1" transform="rotate(-45 4.25 5.66577)" fill="white"/>
                    </svg>
                </div>
            </div>
        </div>
    }

    function getImg(title) {
        if (title.includes('Equifax')) {
            return <img style={{marginTop: 6}} src='/images/equifax.svg'></img>

        }
        if (title.includes('TransUnion') || title.includes('FICORiskScoreClassic')) {
            return <img src='/images/transunion.svg'></img>

        }
        if (title.includes('Experian')) {
            return <img src='/images/experian.svg'></img>

        }
    }
    function getName(title) {
        if (title.includes('Equifax')) {
            return 'Equifax'
        }
        if (title.includes('TransUnion') || title.includes('FICORiskScoreClassic')) {
            return 'TransUnion'

        }
        if (title.includes('Experian')) {
            return 'Experian'
        }
    }
    async function getCreditReport() {
        setLoadingCreditSummaryTable(true);
        let token = sessionStorage.getItem("ZeitroA")
        try {
            const response = await fetch(`/api/v1/credit/getReports?loanId=${encodeURIComponent(urlParams)}`, {
                method: 'get',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache"
                }
            })
            const { code, data, errMessage } = await response.json()
            if (code !== 0) {
                alert(errMessage)
                setParties([{
                    credit: [],
                    liabilities: [],
                    id: "",
                    name: "",
                    type: ''
                },])
            } else {
                if (data.length > 0) {
                    const creditReport = data[0]
                    const checkSelect = data.map((item) => {
                        return {
                            label: `${item.reportType === 'softCheck' ? 'Soft credit pull' : 'Hard credit pull'} ${dayjs(item.createdAt).format('MM/DD/YYYY HH:mm:ss')}`,
                            value: item.id
                        }
                    })
                    setCreditReports(data)
                    setCreditReport(creditReport)
                    setCreditCheckDateOptions(checkSelect)
                    setCreditCheckDate(checkSelect[0].value)
                }
            }
        } catch (e) {
            alert('An error occurred while fetching credit report.');
        } finally {
            setLoadingCreditSummaryTable(false);
        }
    }
    async function handleOwnershipChange (record) {
        setLoadingCreditSummaryTable(true);
        let token = sessionStorage.getItem("ZeitroA")
        try {
            const res = await fetch('/api/v1/credit/updateReport', {
                method: 'PUT',
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: creditCheckDate,
                    liabilities: [record]
                })
            });
            if (!res.ok) {
                setLoadingCreditSummaryTable(false)
                // 错误处理
                alert('Failed to update ownership.')
                return
            }
            await getCreditReport()
        } catch (e) {
            setLoadingCreditSummaryTable(false)
            alert('An error occurred while updating ownership.');
        }
    }
    async function downloadCreditReport() {
        let token = sessionStorage.getItem("ZeitroA")
        try {
            const response = await fetch(`/api/v1/credit/downloadReport`, {
                method: 'POST',
                body: JSON.stringify({
                    id: creditCheckDate,
                    fileType: 'pdf'
                }),
                headers: {
                    Authorization: "Bearer " + token,
                    Cache: "no-cache",
                    "Content-Type": "application/json"
                }
            })
    
            if (!response.ok) {
                alert("Failed to download PDF.")
                return
            }
    
            // 直接获取二进制数据
            const blob = await response.blob()
    
            // 创建下载链接
            const link = document.createElement("a")
            link.href = URL.createObjectURL(blob)
            link.download = 'Credit_Report.pdf'
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link)
    
            // 释放URL对象
            URL.revokeObjectURL(link.href)
    
        } catch (err) {
            alert("An error occurred while downloading the credit report.")
        }
    }
    function setCreditReport(data) {
        setCreditLiability(data.liabilities || [])
        const liabilities = data.liabilities || []
        const creditLoanTypeList = [...new Set(liabilities.map(item => item.loanType))]
            .filter(Boolean)
            .map(item => ({
                value: item,
                label: camelCaseToSpaces(item)
            }))
        const AccountStatusList = [...new Set(liabilities.map(item => item.accountStatus))]
            .filter(item => item && item !== '')
            .map(item => ({
                value: item,
                label: item
            }))

        setAccountStatus(AccountStatusList)
        setCreditLoanType(creditLoanTypeList)
        const parties = convertParties(data)
        setParties(parties)
    }

    function formatName(person) {
        if (!person || !person.lastname) return '--';
        let name = person.lastname;
        if (person.firstname) name += `, ${person.firstname}`;
        if (person.middlename) name += ` ${person.middlename}`;
        if (person.suffix) name += ` ${person.suffix}`;
        return name;
    }

}